import { computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SettingService } from '@millionshow/api-client';

export interface PaymentAccount {
  bankName: string;
  accountNumber: string;
  accountHolder: string;
}

export function createPaymentAccountSignal(
  prefix: string
): Signal<PaymentAccount> {
  const settingService = inject(SettingService);
  const settings = toSignal(
    settingService.settingControllerSearch({
      pageNo: 1,
      pageSize: 20,
      query: `${prefix}_bank_`,
    })
  );

  const getSettingValue = (suffix: string): string =>
    settings()?.items?.find(setting => setting.key === `${prefix}_${suffix}`)
      ?.value ?? '';

  return computed(() => ({
    bankName: getSettingValue('bank_name'),
    accountNumber: getSettingValue('bank_account_number'),
    accountHolder: getSettingValue('bank_account_holder'),
  }));
}
